
            const data = {"name":"prev","data":{"viewBox":"0 0 60 60","data":"<path pid=\"0\" d=\"M30 59l5.27-5.27-20-20H59v-7.5H15.31l20-20L30 1 1 30z\" _fill=\"#171614\"/>","originalColors":[{"type":"fill","color":"#171614"}],"stopColors":[]}}
        
                module.exports = data
                